import i18n from 'i18n';

export enum ENVIRONMENTAL_CROPS_SEED_TYPES {
  SEED_PROCESSED = 'Seed - Processed',
  MIXTURE = 'Mixture',
}

export const ENVIRONMENTAL_CROPS_CONTACT_EMAIL = 'environmentalcrops@frontierag.co.uk';

export const ENVIRONMENTAL_CROPS_SEED_TYPE_LABELS: Record<ENVIRONMENTAL_CROPS_SEED_TYPES, string> =
  {
    [ENVIRONMENTAL_CROPS_SEED_TYPES.SEED_PROCESSED]: 'Standard',
    [ENVIRONMENTAL_CROPS_SEED_TYPES.MIXTURE]: 'Standard mixture',
  };

export const ENV_CROPS_PRICE_UOM_OPTIONS = {
  packs: ['50kse', 'ac100', 'ac50k'],
  units: ['units', 'plant', 'each', 'K300p', 'K300u'],
};

export const ENV_CROPS_PRICE_UOM_LABELS = Object.entries(ENV_CROPS_PRICE_UOM_OPTIONS).reduce(
  (acc, [key, value]) => {
    value.forEach((option) => {
      acc[option] = i18n.t(`envCropsPriceUOMLabels.${key}`, {
        defaultValue: key,
      });
    });
    return acc;
  },
  {} as Record<string, string>,
);

export const ENV_CROPS_DEFAULT_PRICE_UOM = 'kg';

export const ENV_CROPS_MAX_DIGITS_AFTER_DECIMAL = 2;
export const ENV_CROPS_MAX_UNIT_PRICE = 99999999999; // 11 digits
